module.exports = __webpack_public_path__ + "c_static/img/Praise_img_sample-graph_default@2x.ea00ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/05_好评返现/Praise_img_sample-graph_default@2x.png
// module id = /FES
// module chunks = 33